import React from 'react';
import { useTranslation } from 'react-i18next';
import { Callout } from '@blueprintjs/core';
import FormButtons from 'components/FormButtons';
import { FormLayout, FormLayoutContent } from 'components/FormLayout';
import FormPanel from 'components/FormPanel';
import './access-function-form-missing-templates.scss';

type Props = {
  title: string
  onClickCancelClose: () => void
}

const AccessFunctionFormMissingTemplates = ({
  title,
  onClickCancelClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="access-function-form access-function-form-missing-template" data-testid="AccessFunctionFormMissingTemplates">
      <FormLayout>
        <FormLayoutContent>
          <FormPanel title={title}>
            <FormButtons
              isEditing
              onClickCancel={onClickCancelClose}
              onClickClose={onClickCancelClose}
            />
          </FormPanel>
          <div className="callout">
            <Callout
              title={t('accessFunction.create.missingTemplate.title')}
              icon="error"
              intent="danger"
            >
              {t('accessFunction.create.missingTemplate.message')}
            </Callout>
          </div>
        </FormLayoutContent>
      </FormLayout>
    </div>
  );
};

export default AccessFunctionFormMissingTemplates;
